import { useUiVersion } from 'hooks';
import { Plate } from 'grids/plate/plate';

export const PlatesWrapper = (props) => {
  const { isNew } = useUiVersion();
  const theme = isNew ? undefined : 'dark';

  return <Plate {...props} theme={theme} className="in-client" />;
};
